module.exports = __webpack_public_path__ + "img/human_genetics.e63d4565.svg";